import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { NumberKMPipe } from '../../../../../pipes/numberKMPipe';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';


@Component({
  selector: 'app-promo-customer-performance',
  templateUrl: './promo-performance.component.html',
  styleUrls: ['./promo-performance.component.css']
})
// Pagina 53
export class PromoPerformanceComponent implements OnInit {
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  public indicators: IndicatorBoxModel[] = [];
  public promoError = false;
  public data: QFilterModel;

  show_results = false;
  promoUsersChart: LoyaltyChart;
  associatedExpensePromoChart: LoyaltyChart;

  constructor (
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  ngOnInit() {
    this.initCharts();
  }

  initCharts() {
    this.promoUsersChart = new LoyaltyChart('line');
    this.promoUsersChart.options.xAxis.title.text = '';
    this.promoUsersChart.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.promoUsersChart.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };

    this.associatedExpensePromoChart = new LoyaltyChart('line');
    this.associatedExpensePromoChart.options.xAxis.title.text = '';
    this.associatedExpensePromoChart.options.yAxis.labels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.value, '€');
    };
    this.associatedExpensePromoChart.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y, '€');
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {
    this.data = data;

    if (data['promo'] != null) {
      this.indicators = [];

      this.indicatorService.indicatorCalculation('promos.Q242', this.data).subscribe(
        Q242 => {

          /*Q242*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'totale_utilizzatori_promo')], {dynamic: true, decimal_value: 0, hide_prev_value: true}));
          /*Q243*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'utilizzatori_promo_nuovi_clienti')], {dynamic: true, decimal_value: 0, hide_prev_value: true}));
          /*Q244*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'totale_spesa_associata')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
          /*Q245*/
          this.indicators.push(new IndicatorBoxModel([Q242.find(r => r.name === 'spesa_associata_nuovi_clienti')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));

        });

      this.show_results = true;

      this.chartsService.loadChart(this.promoUsersChart, 'promos.Q246', data, this.indicatorService, this.translate, false, LoyaltyChart.colors, 'indicator');
      this.chartsService.loadChart(this.associatedExpensePromoChart, 'promos.Q247', data, this.indicatorService, this.translate, false, LoyaltyChart.colors, 'indicator');
    } else {
      this.data = null;
      this.promoError = true;
    }

  }

  public toogleErrorPromoDialog() {
    this.promoError = !this.promoError;
  }


  public get filterApplied(): boolean {
    return this.data != null;
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/customer/performance/promo-performance.component.ts